import { ApiResponse } from '../http/BaseHttpClient';
import { IAccountProfile } from '../types';
import AbstractService from './AbstractService';

export type IProfileFormData = IAccountProfile;

export class AccountService extends AbstractService {

  async getProfile(token?: string): Promise<IAccountProfile> {
    const response = await this.request<IAccountProfile>({
      method: 'get',
      baseURL: '/api',
      url: '/auth/me',
      token,
    });
    const profile = (response as any)?.data ?? response;

    return profile;
  }

  async createCustomer(data: Partial<IAccountProfile>, token?: string): Promise<ApiResponse<IAccountProfile>> {
    const response = await this.post<IAccountProfile>(this.endpoint('catalogCustomers'), data, { token });
    return response;
  }

  async updateProfile(data: Partial<IAccountProfile> & { id?: string | number } = {}, token?: string): Promise<ApiResponse<IAccountProfile>> {
    let id = data.id ?? (data as any).customerId;

    if (!id) {
      // Fallback: try to resolve current profile to get an id.
      const profile = await this.getProfile(token);
      id = (profile as any)?.id ?? (profile as any)?.customerId;
    }

    if (!id) {
      throw new Error('AccountService: Missing customer id while updating profile');
    }

    const payload = { ...data } as any;
    delete payload.id;
    delete payload.customerId;

    const response = await this.patch<IAccountProfile>(this.endpoint('catalogCustomersById', { id }), payload, { token });
    return response;
  }

  async getCartHistory(params?: Record<string, any>, token?: string): Promise<ApiResponse<any>> {
    return this.get<any>(this.endpoint('carts'), params, { token });
  }

  async getCartById(cartId: string, token?: string): Promise<ApiResponse<any>> {
    return this.get<any>(this.endpoint('cartById', { cartId }), undefined, { token });
  }
}

export const accountService = new AccountService();

export default AccountService;
